import React from 'react';
import { useParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import FolderConfigurations from '../components/FolderConfigurations';
import './Configurations.css';

const Configurations = () => {
  const { type } = useParams();

  return (
    <div 
    style={{
        position:"fixed",
        top:0,
        width:"100%"
      }}

    >
      <div className="content">
        <Navigation></Navigation>
        <FolderConfigurations type='{type}'></FolderConfigurations> 
      </div>
    </div>
  );
};

export default Configurations;
